export default {
	idFornecedorItemAta: null,
	novoValor: null,
	novaMarca: null,
	justificativa: null,
	fornecedor: null,
	anexo: null,
	idsExternoAnexoFlowbee: [],
}
